import dateFormat from 'dateformat';
import { orderBy } from 'firebase/firestore';
import { useFormik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import Dropdown, { DropdownMenu, DropdownToggle } from '../../../../components/bootstrap/Dropdown';
import Spinner from '../../../../components/bootstrap/Spinner';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Input from '../../../../components/bootstrap/forms/Input';
import Label from '../../../../components/bootstrap/forms/Label';
import Select from '../../../../components/bootstrap/forms/Select';
import { DefaultContext } from '../../../../contexts/default';
import StoreDB from '../../../../database/wrappers/store';
import Money from '../../../../helpers/utils/money/money';
import useSalesProductsPerHour from '../../../../hooks/reports/useSalesProductsPerHour';
import useDarkMode from '../../../../hooks/useDarkMode';
import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import { demoPages } from '../../../../menu';
import { ACCESS_LEVEL } from '../../../../types/roles';

const ProductsPerHours = () => {
  const { themeStatus } = useDarkMode();
  const { accessLevel, establishments, estabSelected, setestabSelected } = useContext(DefaultContext);
  const [storesInFilter, setstoresInFilter] = useState([]);
  const [filterMenu, setFilterMenu] = useState(false);
  const { getData, loading, productsPerHour } = useSalesProductsPerHour();

  const formik = useFormik({
    initialValues: {
      estab: '',
      store: '#',
      firstDate: dateFormat(new Date(), 'yyyy-mm-dd'),
      secondDate: dateFormat(new Date(), 'yyyy-mm-dd'),
      firstHour: '00:00',
      secondHour: '23:59',
    },
    onSubmit: (values) => {
      setFilterMenu(false);
      setestabSelected(values.estab);
      getData(values);
    },
  });

  useEffect(() => {
    formik.setFieldValue('estab', estabSelected);
  }, []);

  useEffect(() => {
    if (formik.values.estab) {
      new StoreDB(formik.values.estab)
        .getAll(orderBy('name', 'asc'))
        .then(datas => {
          setstoresInFilter(datas);
          formik.setFieldValue('store', '#');
        })
        .catch(error => console.error(error));
    }
  }, [formik.values.estab]);

  const optionsEstablishments = useMemo(() =>
    establishments.map(item => ({ value: item.id, text: item.name }))
    , [establishments]);

  const optionsStores = useMemo(() => [
    { value: '#', text: 'Todas' },
    ...storesInFilter.map(item => ({ value: item.id, text: item.name })),
  ], [storesInFilter]);

  const columns = useMemo(() => ([
    {
      label: 'Período',
      field: 'period',
    },
    {
      label: 'Nome',
      field: 'name',
    },
    {
      label: 'Quantidade',
      field: 'qtd',
    },
    {
      label: 'Total',
      field: 'total',
      format: row => Money.centsToMaskMoney(row.total),
      isCurrency: true,
    },
  ]), []);

  return (
    <PageWrapper title={demoPages.reports.subMenu.productsPerHours.text}>
      <SubHeader>
        <SubHeaderLeft>
          <Breadcrumb
            list={[
              { title: 'Relatórios', to: '/reports' },
              {
                title: 'Produtos por hora',
                to: '/reports/productsPerHours',
              },
            ]}
          />
        </SubHeaderLeft>
        <SubHeaderRight>
          <Dropdown isOpen={filterMenu} setIsOpen={setFilterMenu}>
            <DropdownToggle hasIcon={false}>
              <Button
                style={filterMenu ? { color: themeStatus === 'dark' ? 'black' : 'white' } : {}}
                className='text-dark'
                icon='Filter'
                color='warning'
                data-tour='filter'>
                Filtros
              </Button>
            </DropdownToggle>

            <DropdownMenu
              isAlignmentEnd
              size='lg'
              isCloseAfterLeave={false}
              data-tour='filter-menu'>
              <div className='container py-2'>
                <form className='row g-3' onSubmit={formik.handleSubmit}>
                  {(accessLevel === ACCESS_LEVEL.ADMIN || accessLevel === ACCESS_LEVEL.MANAGER) && (
                    <div className='col-12'>
                      <FormGroup>
                        <Label htmlFor='estab'>Estabelecimento</Label>
                        <Select
                          id='estab'
                          placeholder='Selecione o estabelecimento'
                          list={optionsEstablishments}
                          onChange={formik.handleChange}
                          value={formik.values.estab}
                        />
                      </FormGroup>
                    </div>
                  )}
                  <div className='col-12'>
                    <FormGroup>
                      <Label htmlFor='store'>Loja</Label>
                      <Select
                        id='store'
                        placeholder='Selecione a loja'
                        list={optionsStores}
                        onChange={formik.handleChange}
                        value={formik.values.store}
                      />
                    </FormGroup>
                  </div>

                  <div className='col-12'>
                    <FormGroup>
                      <Label htmlFor='firstDate'>Data de Inicio</Label>
                      <Input
                        id='firstDate'
                        type='date'
                        ariaLabel='First Date'
                        onChange={formik.handleChange}
                        value={formik.values.firstDate}
                      />
                    </FormGroup>
                  </div>
                  <div className='col-12'>
                    <FormGroup>
                      <Label htmlFor='secondDate'>Data Final</Label>
                      <Input
                        id='secondDate'
                        type='date'
                        ariaLabel='Second Date'
                        onChange={formik.handleChange}
                        value={formik.values.secondDate}
                      />
                    </FormGroup>
                  </div>

                  <div className='d-flex flex-row justify-content-between gap-3'>
                    <FormGroup>
                      <Label htmlFor='firstHour'>Hora início</Label>
                      <Input
                        id='firstHour'
                        type='time'
                        ariaLabel='First Hour'
                        onChange={formik.handleChange}
                        value={formik.values.firstHour}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor='secondHour'>Hora final</Label>
                      <Input
                        id='secondHour'
                        type='time'
                        ariaLabel='Second Hour'
                        onChange={formik.handleChange}
                        value={formik.values.secondHour}
                      />
                    </FormGroup>
                  </div>

                  <div className='col-12'>
                    <Button style={{ color: 'black' }} icon='Search' color='warning' className='w-100' type='submit'>
                      Buscar Dados
                    </Button>
                  </div>
                </form>
              </div>
            </DropdownMenu>
          </Dropdown>
        </SubHeaderRight>
      </SubHeader>
      <Page container='fluid' className='h-100'>
        {loading ? (
          <div className='d-flex flex-column justify-content-center align-items-center h-100'>
            <Spinner size={50} />
          </div>
        ) : (
          <Card>
            <CardHeader borderSize={1}>
              <CardLabel icon='QueryBuilder' iconColor='dark'>
                <CardTitle>PRODUTOS POR HORA</CardTitle>
              </CardLabel>
            </CardHeader>
            <CardBody className='table-responsive p-5'>
              <TableCustom
                titlePdf='Produto por Hora'
                fontSize={8}
                columns={columns}
                rows={productsPerHour}
                keyExtractor={row => row.id}
                fileName='Produto-por-Hora'
              />
            </CardBody>
          </Card>
        )}
      </Page>
    </PageWrapper>
  );
};

export default ProductsPerHours;
